import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';


//custom components
import Nav from './components/Nav';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
  
          <small className="App-title">DL</small>
        </header>
        <Nav /> <br /><br /><br /><br /><br /> <br /><br /><br /><br /><br /> <br /><br /><br /><br /><br />
        <small>DesignLove Software - Enterprise .NET and JS systems - 2009 - 2019 - Copyright</small>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js